/**
 * "HR starts this in the HR Portal" (21 Oct, Rusty; 28 Oct: the HelpDesk
 * starts Change access only).
 *
 * One line on the chat's access card for a New user or a Leaver, and on the
 * wizard ("New user or leaver? …", `lead`). The link is HR_PORTAL_URL;
 * unset, the line shows without one.
 */

import { ExternalLink, Icon } from "@norican/icons";
import { cn, Typography } from "@norican/react";

import { useT } from "@/i18n";

import { hrPortalHref, showsHrPortal } from "../lib/hr-portal";

export interface HrPortalHintProps {
  /** The access type: shown for "new" and "leave" only. */
  type: string | null | undefined;
  url?: string | null;
  /** The wizard's line: names what HR starts, whatever the type. */
  lead?: boolean;
  className?: string;
}

export function HrPortalHint({ type, url, lead = false, className }: HrPortalHintProps) {
  const { t } = useT("tickets");
  if (!lead && !showsHrPortal(type)) {
    return null;
  }
  const href = hrPortalHref(url);
  return (
    <Typography variant="body-sm" tone="muted" className={cn(className)}>
      {lead ? t("access.hrPortal.lead") : t("access.hrPortal.text")}
      {href === null ? null : (
        <>
          {" "}
          <a
            href={href}
            target="_blank"
            rel="noreferrer"
            className="text-accent-fg-subtle inline-flex items-center gap-1 hover:underline"
          >
            {t("access.hrPortal.link")}
            <Icon icon={ExternalLink} size="xs" />
          </a>
        </>
      )}
    </Typography>
  );
}
